import { css } from '@emotion/react';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { SpinnerBlock } from 'components/SpinnerBlock';
import { useOrganizationQuery, useUpdateOrganizationPrimaryEmailMutation } from 'generated/graphql';
import { useStore } from 'hooks/useStore';
import { useForm } from 'react-hook-form';
import { emailValidation } from 'screens/booking/forms/validations';

export const OrganizationPrimaryEmailForm = () => {
	const [organization, _reexecuteOrganiation] = useOrganizationQuery();

	return organization.fetching ? <SpinnerBlock v={3} /> : <Form organization={organization} />;
};

const Form = ({ organization }) => {
	const defaultValues = {
		email: organization.data?.organization?.email,
	};

	const { notifications } = useStore();

	const [{ fetching }, updateEmail] = useUpdateOrganizationPrimaryEmailMutation();

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		defaultValues: defaultValues,
	});

	const onSubmit = (data) => {
		updateEmail({
			email: data.email,
		}).then((result) => {
			if (!result.error) {
				notifications.addNotification({ title: '✅ Hotovo', message: 'E-mail byl změněn.' });
			}
		});
	};

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			css={css`
				display: flex;
				gap: 8px;
			`}
		>
			<div
				css={css`
					display: flex;
					gap: 8px;
					flex-direction: column;
					flex-grow: 1;
				`}
			>
				<Input
					placeholder="@"
					{...register('email', emailValidation({ required: 'Zadejte e-mail.' }))}
					error={!!errors['email']}
				/>
				{!!errors.email && (
					<div
						css={css`
							width: 100%;
							font-size: 13px;
							line-height: 16px;
							font-weight: 600;
							color: #ff6767;
							padding-top: 8px;
						`}
					>
						{errors.email.message}
					</div>
				)}
			</div>

			<Button isProcessing={fetching}>Aktualizovat</Button>
		</form>
	);
};
